import {PureComponent} from 'react';
import {connect} from 'react-redux';

import * as ramda from 'ramda';

import {convertToArray} from 'nutshell-core/filter';

import type {MultiPageFormFragment} from 'nutshell-graphql-types';

import {makeHandleClickChartToZoom} from '../../../reports/charts/make-handle-click-chart-to-zoom';
import {
    GAP_SELECT_VALUES_DAY_TO_YEAR,
    getReportDateRanges,
} from '../../../reports/report-constants';
import {ReportDateRangePickerSimple} from '../../../reports/report-date-range-picker-simple';
import type {ReportURLParams} from '../../../reports/report-types';
import * as reportSelectors from '../../../reports/reports-selectors';

import type {NutshellState} from '../../../../store';

import * as actions from '../../forms-actions';
import type {FormEngagementChartParams} from '../../forms-utils';

import {FormsReportChart} from '../form-engagement/forms-report-chart';

import styles from '../form-engagement/form-engagement-report.module.css';

type OwnProps = {
    form: MultiPageFormFragment;
    onParamChange: (arg1: any, arg2: boolean) => any;
    onParamPush: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
};

type StateProps = {
    chartBucketCount: number;
};

type DispatchProps = {
    fetchReportData: (arg1: FormEngagementChartParams, arg2: any[]) => any;
};

type Props = OwnProps & StateProps & DispatchProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        chartBucketCount: reportSelectors.getCurrentReportChartBucketCount(state),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch) {
    return {
        // @ts-expect-error
        fetchReportData: (reportParams, filters) => {
            dispatch(actions.requestFormEngagementReportData({reportParams, filters}));
        },
    };
}

class MultiPageFormEngagementReportComponent extends PureComponent<Props> {
    static defaultProps = {
        urlParams: {
            report: {},
            filter: {},
        },
    };

    componentDidMount() {
        const filters = convertToArray(this.props.urlParams.filter);
        const reportParams = this.props.urlParams.report;

        this.props.fetchReportData(
            {
                ...reportParams,
                formId: this.props.form.id,
            },
            filters
        );
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        const {
            urlParams: {report: nextReportParams, filter: nextFilterParams},
        } = nextProps;

        const {
            urlParams: {report: reportParams, filter: filterParams},
            form,
        } = this.props;

        const filtersChanged = !ramda.equals(nextFilterParams, filterParams);
        const gapChanged = nextReportParams.gap !== reportParams.gap;
        const formChanged = nextProps.form.id !== form.id;

        const universalPropsChanged = filtersChanged;

        if (gapChanged || universalPropsChanged || formChanged) {
            const nextFilters = convertToArray(nextFilterParams);
            this.props.fetchReportData(
                {
                    ...nextReportParams,
                    formId: nextProps.form.id,
                },
                nextFilters
            );
        }
    }

    render() {
        const reportParams = this.props.urlParams.report || {};
        const currentGapIndex = GAP_SELECT_VALUES_DAY_TO_YEAR.findIndex((gap) => {
            return gap.id === reportParams.gap;
        });

        return (
            <div id='form-engagement-report' className={styles['form-engagement-report']}>
                <ReportDateRangePickerSimple
                    activeFilters={convertToArray(this.props.urlParams.filter)}
                    dateRangeType='period'
                    // @ts-expect-error
                    dateRangeOptions={getReportDateRanges('formEngagement')}
                    onDateRangeChange={(newFilter) => {
                        this.props.onParamChange(
                            {filter: {...this.props.urlParams.filter, ...newFilter}},
                            true
                        );
                    }}
                />
                <FormsReportChart
                    hasBorder={false}
                    activeFilters={convertToArray(this.props.urlParams.filter)}
                    // @ts-expect-error
                    onChartClick={makeHandleClickChartToZoom(
                        currentGapIndex,
                        this.props.chartBucketCount,
                        this.props.onParamPush,
                        this.props.urlParams.report.dateRangeType
                    )}
                    height={475}
                    onParamChange={this.props.onParamChange}
                    reportParams={reportParams}
                />
            </div>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
// @ts-expect-error
export const MultiPageFormEngagementReport = connector(MultiPageFormEngagementReportComponent);
